export const getMobileOS = async (): Promise<string> => '';
